<template>
	<div class="kanban-view" :style="_style">
		<div v-for="(column, i) in _columns" :key="i" class="column">
			<div class="header">{{ column.name }}</div>
			<div class="tasks">
				<task-view class="task" />
				<task-view class="task" />
				<task-view class="task" />
			</div>
		</div>
		<div class="fill"></div>
	</div>
</template>

<script>
	export default {
		props: {
			users: {
				type: Array,
				required: true
			}
		},
		computed: {
			_style() {
				return {
					'grid-template-columns': `repeat(${this._columns.length}, 320px) 1fr`
				};
			},
			_columns() {
				var r = [];

				for (var i = 0; i < this.users.length; ++i) {
					r.push(this.users[i]);
				}

				return r;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.kanban-view {
		display: grid;
		grid-template-rows: 1fr;

		& > .column {
			height: 100%;
			border-right: 1px solid #cecece;

			& > .header {
				text-align: center;
				border-bottom: 1px solid #cecece;
				background-color: white;
				line-height: 40px;
			}

			& > .tasks {
				margin: 20px 0 0 0;
				padding: 0 20px 0 20px;
			}
		}
	}
</style>